import styled, { css } from 'styled-components';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { p as paddingMixin, m as mobilePaddingMixin } from '../theme/style-mixins/padding/index-BPYuRWh5.js';
import { I as Icon } from '../Icon/Icon-AcXbY_t4.js';

const Header = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-ttofv1-0"
})(["background-color:", ";border-bottom:", ";box-sizing:border-box;padding-block:", ";padding-inline:", ";position:fixed;top:0;width:100%;z-index:1;"], ({
  theme
}) => theme.button.backgroundColor.secondary.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.xxsmall.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile);
Header.displayName = 'Header';
const Content = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-ttofv1-1"
})(["margin-top:51px;overflow-x:auto;height:100%;", " ", ""], paddingMixin, isMobile(css(["", ""], mobilePaddingMixin)));
Content.displayName = 'Content';
const CloseButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40027066__sc-ttofv1-2"
})(["font:", ";border:none;background:transparent;color:", ";overflow:hidden;text-align:start;text-overflow:ellipsis;white-space:nowrap;margin-top:0;margin-bottom:0;width:100%;padding-block:0px;padding-inline:0px;&&:hover{color:", ";cursor:pointer;}", " &&:focus-visible{outline:none;", "}"], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.text.color.secondary, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)), focusOutline);
CloseButton.displayName = 'CloseButton';
const CloseButtonIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-ttofv1-3"
})(["margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.xxxsmall.mobile);
CloseButtonIcon.displayName = 'CloseButtonIcon';
const Shroud = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-ttofv1-4"
})(["position:fixed;top:0;right:auto;bottom:auto;left:0;height:100vh;width:100vw;display:flex;align-items:center;justify-content:center;@media (prefers-reduced-motion:no-preference){transition:opacity 150ms ease-in-out;}opacity:", ";z-index:", ";"], ({
  $transitionState
}) => {
  if ($transitionState === 'entered') {
    return 1;
  }
  return 0;
}, ({
  theme
}) => theme.elevation.zIndex.layer4);
Shroud.displayName = 'Shroud';

export { CloseButton as C, Header as H, Shroud as S, CloseButtonIcon as a, Content as b };
//# sourceMappingURL=SecondaryView.styles-B4UFiy5D.js.map
